import * as types from './VolumeTrendActionType.jsx';

// Volumne Trend Report Actions
export const volumeTrendReportRequest = (payload) => ({
    type: types.VOLUME_TREND_REQUEST,
    payload: payload
});
export const volumeTrendReportSuccess = (data) => ({
    type: types.VOLUME_TREND_SUCCESS,
    payload: data
});
export const volumeTrendReportFailure = (error) => ({
    type: types.VOLUME_TREND_FAILURE,
    payload: error
});

//Pivot Volume Trend By ID Actions
export const pivotVolumeTrendByIdRequest = (payload) => ({
    type: types.PIVOT_VOLUME_TREND_BY_ID_REQUEST,
    payload: payload
});

export const pivotVolumeTrendByIdSuccess = (data) => ({
    type: types.PIVOT_VOLUME_TREND_BY_ID_SUCCESS,
    payload: data
});

export const pivotVolumeTrendByIdFailure = (error) => ({
    type: types.PIVOT_VOLUME_TREND_BY_ID_FAILURE,
    payload: error
});

//Unread Pivot Volume Trend By ID Actions
export const unreadPivotVolumeTrendByIdRequest = (payload) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_REQUEST,
    payload: payload
});

export const unreadPivotVolumeTrendByIdSuccess = (data) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SUCCESS,
    payload: data
});

export const unreadPivotVolumeTrendByIdFailure = (error) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_FAILURE,
    payload: error
});

//Unread Pivot Volume Trend By ID Site Actions
export const unreadPivotVolumeTrendByIdSiteRequest = (payload) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_REQUEST,
    payload: payload
});
export const unreadPivotVolumeTrendByIdSiteSuccess = (data) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_SUCCESS,
    payload: data
});
export const unreadPivotVolumeTrendByIdSiteFailure = (error) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_FAILURE,
    payload: error
});
export const unreadPivotVolumeTrendByIdSitePriorityRequest = (payload) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_REQUEST,
    payload: payload
});
export const unreadPivotVolumeTrendByIdSitePrioritySuccess = (data) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_SUCCESS,
    payload: data
});
export const unreadPivotVolumeTrendByIdSitePriorityFailure = (error) => ({
    type: types.UNREAD_PIVOT_VOLUME_TREND_BY_ID_SITE_PRIORITY_FAILURE,
    payload: error
});


// RollOver ExamData Volume Trend Actions
export const rollOverExamDataVolumeTrendRequest = (payload) => ({
    type: types.ROLLOVER_EXAMDATA_VOLUME_TREND_REQUEST,
    payload: payload
});
export const rollOverExamDataVolumeTrendSuccess = (data) => ({
    type: types.ROLLOVER_EXAMDATA_VOLUME_TREND_SUCCESS,
    payload: data
});

export const rollOverExamDataVolumeTrendFailure = (error) => ({
    type: types.ROLLOVER_EXAMDATA_VOLUME_TREND_FAILURE,
    payload: error
});

// Delete Scheduling ForeCast Report Actions
export const deleteSchedulingForecastReportRequest = (payload) => ({
    type: types.DELETE_SCHEDULING_FORECAST_REPORT_REQUEST,
    payload: payload
});
export const deleteSchedulingForecastReportSuccess = (data) => ({
    type: types.DELETE_SCHEDULING_FORECAST_REPORT_SUCCESS,
    payload: data
});
export const deleteSchedulingForecastReportFailure = (error) => ({
    type: types.DELETE_SCHEDULING_FORECAST_REPORT_FAILURE,
    payload: error
});

// Get Volume Trend Reports By ID Actions
export const getVolumeTrendReportsByIdRequest = (payload) => ({
    type: types.GET_VOLUME_TREND_REPORTS_BY_ID_REQUEST,
    payload: payload
});
export const getVolumeTrendReportsByIdSuccess = (data) => ({
    type: types.GET_VOLUME_TREND_REPORTS_BY_ID_SUCCESS,
    payload: data
});
export const getVolumeTrendReportsByIdFailure = (error) => ({
    type: types.GET_VOLUME_TREND_REPORTS_BY_ID_FAILURE,
    payload: error
});
export const getVolumeTrendSchedulingForecastByIdRequest = (payload) => ({
    type: types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_REQUEST,
    payload: payload
});
export const getVolumeTrendSchedulingForecastByIdSuccess = (data) => ({
    type: types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_SUCCESS,
    payload: data
});
export const getVolumeTrendSchedulingForecastByIdFailure = (error) => ({
    type: types.GET_VOLUME_TREND_SCHEDULING_FORECAST_BY_ID_FAILURE,
    payload: error
});

// Save Volume Trend Report Actions
export const saveVolumeTrendReportRequest = (payload) => ({
    type: types.SAVE_VOLUME_TREND_REPORT_REQUEST,
    payload: payload
});
export const saveVolumeTrendReportSuccess = (data) => ({
    type: types.SAVE_VOLUME_TREND_REPORT_SUCCESS,
    payload: data
});
export const saveVolumeTrendReportFailure = (error) => ({
    type: types.SAVE_VOLUME_TREND_REPORT_FAILURE,
    payload: error
});

// Draft Save Volume Trend Report Actions
export const draftSaveVolumeTrendReportRequest = (payload) => ({
    type: types.DRAFT_SAVE_VOLUME_TREND_REPORT_REQUEST,
    payload: payload
});
export const draftSaveVolumeTrendReportSuccess = (data) => ({
    type: types.DRAFT_SAVE_VOLUME_TREND_REPORT_SUCCESS,
    payload: data
});
export const draftSaveVolumeTrendReportFailure = (error) => ({
    type: types.DRAFT_SAVE_VOLUME_TREND_REPORT_FAILURE,
    payload: error
});

// Publish Volume Trend Report Actions
export const publishVolumeTrendReportRequest = (payload) => ({
    type: types.PUBLISH_VOLUME_TREND_REPORT_REQUEST,
    payload: payload
});
export const publishVolumeTrendReportSuccess = (data) => ({
    type: types.PUBLISH_VOLUME_TREND_REPORT_SUCCESS,
    payload: data
});
export const publishVolumeTrendReportFailure = (error) => ({
    type: types.PUBLISH_VOLUME_TREND_REPORT_FAILURE,
    payload: error
});

// Export Volume Trend Report Actions
export const exportVolumeTrendReportRequest = (payload) => ({
    type: types.EXPORT_VOLUME_TREND_REPORT_REQUEST,
    payload: payload
});
export const exportVolumeTrendReportSuccess = (data) => ({
    type: types.EXPORT_VOLUME_TREND_REPORT_SUCCESS,
    payload: data
});
export const exportVolumeTrendReportFailure = (error) => ({
    type: types.EXPORT_VOLUME_TREND_REPORT_FAILURE,
    payload: error
});

// Report Note Actions
export const reportNoteRequest = (payload) => ({
    type: types.REPORT_NOTE_REQUEST,
    payload: payload
});
export const reportNoteSuccess = (data) => ({
    type: types.REPORT_NOTE_SUCCESS,
    payload: data
});
export const reportNoteFailure = (error) => ({
    type: types.REPORT_NOTE_FAILURE,
    payload: error
});

//Save Report Note Actions

export const saveReportNoteRequest = (payload) => ({
    type: types.SAVE_REPORT_NOTE_REQUEST,
    payload: payload
});
export const saveReportNoteSuccess = (data) => ({
    type: types.SAVE_REPORT_NOTE_SUCCESS,
    payload: data
});
export const saveReportNoteFailure = (error) => ({
    type: types.SAVE_REPORT_NOTE_FAILURE,
    payload: error
});

// Get Exam Data Volume Trend Actions (for Roll Over Demand)
export const getExamDataVolumeTrendRequest = (payload) => ({
    type: types.GET_EXAM_DATA_VOLUME_TREND_REQUEST,
    payload: payload
});

export const getExamDataVolumeTrendSuccess = (data) => ({
    type: types.GET_EXAM_DATA_VOLUME_TREND_SUCCESS,
    payload: data
});

export const getExamDataVolumeTrendFailure = (error) => ({
    type: types.GET_EXAM_DATA_VOLUME_TREND_FAILURE,
    payload: error
});

// Get Volume Trend Dropdowns Actions
export const getVolumeTrendDropDownsRequest = (payload) => ({
    type: types.GET_VOLUME_TREND_DROPDOWNS_REQUEST,
    payload: payload
});

export const getVolumeTrendDropDownsSuccess = (data) => ({
    type: types.GET_VOLUME_TREND_DROPDOWNS_SUCCESS,
    payload: data
});

export const getVolumeTrendDropDownsFailure = (error) => ({
    type: types.GET_VOLUME_TREND_DROPDOWNS_FAILURE,
    payload: error
});

// Reset Rollover ExamData
export const resetRolloverExamData = () => ({
    type: types.RESET_ROLLOVER_EXAMDATA
});